import React from "react";

class FlippingBook extends React.Component {
  constructor(props) {
    super(props);
    this.data = props.data;
    this.scriptElem = document.createElement("script");
    this.scriptElem.src = this.data.scriptUrl;
    this.scriptElem.async = true;
  }

  componentDidMount() {
    document.body.appendChild(this.scriptElem);
    document.body.classList.add("course-book-modal");
  }
  componentWillUnmount() {
    document.body.removeChild(this.scriptElem);
    document.body.classList.remove("course-book-modal");
  }

  render() {
    const data = this.data;
    const BookHtml = data.html;
    return (
      <table>
        <tr>
          <td style={{ verticalAlign: "top" }}>
            <BookHtml />
          </td>
          <td style={{ textAlign: "left", verticalAlign: "top" }}>
            <span className="flip-book-open-prompt">
              Click on the book cover to open your e-book
            </span>
            <br />
            <a
              href={this.data.bookUrl}
              className="fbo-embed"
              data-fbo-id={this.data.fboId}
              data-fbo-ratio="16:9"
              data-fbo-lightbox="yes"
              data-fbo-version="1"
            >
              Companion Book
            </a>
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            Use the 'Search' tool to easily find topics. Use the 'Print' icon to
            print selected page ranges. Looking for a printed copy of this book?
            <span className="buy-book-callout">
              {" "}
              Purchase a spiral-bound, full color version{" "}
              <a href={this.data.productUrl}>HERE</a>
            </span>
          </td>
        </tr>
      </table>
    );
  }
}

export default FlippingBook;
